import { trackEvent } from "src/Amplitude";
import { Input, useTheme } from "@mui/material";
import React from "react";

interface TransactionInputProps {
  id?: string;
  placeHolder: string;
  value: number | string | undefined;
  hasError: boolean;
  reseted: string | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputBlurHandler: () => void;
}

const TransactionSizeInput = (props: TransactionInputProps) => {
  const { id, placeHolder, value, reseted, onChange, inputBlurHandler, hasError } = props;
  const theme = useTheme();
  const secondary = theme.palette.secondary.main;
  const [selected, setSelected] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (value) {
      setSelected(true);
    } else {
      setSelected(false);
    }
  }, [value]);

  const Styles = (hasError: boolean) => {
    if (hasError) {
      return {
        border: `1px solid ${secondary}`,
      };
    }
    return {
      border: "1px solid #e5e7e8",
      backgroundColor: selected ? "#e5e9eb" : "white",
    };
  };

  return (
    <Input
      id={id}
      key={reseted}
      value={value !== undefined ? value : ""}
      placeholder={placeHolder}
      disableUnderline
      onChange={onChange}
      onFocus={(event) => event.target.select()}
      onBlur={inputBlurHandler}
      onClick={() => trackEvent("Select_Trade_Order_Currency_Price_Input_Field")}
      sx={{
        borderRadius: "10px",
        height: "100%",
        width: "100%",
        textTransform: "none",
        "&:hover": {
          border: hasError ? `1px solid ${secondary}` : "1px solid #002035",
        },
        "& .MuiInput-input": {
          textAlign: "center",
          fontSize: "14px",
          fontWeight: hasError ? 600 : "unset",
          color: hasError ? secondary : selected ? "#000" : "#7b858b",
        },
        ...Styles(hasError),
      }}
      inputProps={{
        height: "33px",
        inputMode: "numeric",
        min: "0",
        pattern: "[0-9]*",
      }}
    />
  );
};

export default TransactionSizeInput;
